<template>
  <form style="padding: 20px">  
    <v-snackbar
      top right
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ $t('rcovid.messageSend') }}
    </v-snackbar>
    <center class="label-form">
      {{$t('rcovid.name').toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="name"
      :counter="150"
      required
    />
    <center class="label-form">
      {{$t('rcovid.ni').toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="ni"
      :counter="10"
      required
    />
    <center class="label-form">
      {{$t('rcovid.phone').toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="phone"
      :counter="15"
      required
    />    
    <v-alert
      v-if="error"
      color="red"
      dense
      text
      icon="mdi-information"
      border="left"
    >
      {{ $t('common.required') }}
    </v-alert>
    <v-btn :color="BGColorSecundary" :style="{ 'color': ColorSecundary}" dark block style="margin-top:20px;height:50px;" @click="handleSubmit">{{ text ? text : $t('common.send') }}</v-btn>    
  </form>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email, sameAs } from 'vuelidate/lib/validators'
  import constants from '@/constants'
  import axios from 'axios'
  import utils from '@/services/utils'
  export default {
    mixins: [validationMixin],
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      snackbar: false,
      timeout: 2000,

      modalDate: false,
      times: [],
      loading: false,
      name: '',
      ni: '',
      phone: '',

      // name: process.env.VUE_APP_ENV === 'development' ? 'Javier' : '',
      // roomNum: null,
      // email: process.env.VUE_APP_ENV === 'development' ? 'javier@descubregroup.com' : '',
      // phone: process.env.VUE_APP_ENV === 'development' ? '666666666' : '',
      // date: process.env.VUE_APP_ENV === 'development' ? new Date().toISOString().split('T')[0] : '',
      // time: process.env.VUE_APP_ENV === 'development' ? '11:11' : '',
      // numOfPeople: 1,
      // observations: process.env.VUE_APP_ENV === 'development' ? 'Observaciones' : '',
      error: false
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return this.data.FormTextBtn ? utils.getTranslation (this.data.FormTextBtn, this.locale) : null
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push(this.$t('enterprises.messages.nameMostCharacters'))
        !this.$v.name.required && errors.push(this.$t('enterprises.messages.nameRequired'))
        return errors
      },
    },
    watch: {
      validations() { 
        return {
          name: { required, maxLength: maxLength(150) },
        }
      },
    },
    mounted () {
      if(process.env.VUE_APP_ENV === 'development') {
        this.name = 'ppp'
        this.ni = 'ppp'
        this.phone = 'ppp'
      }
    },
    methods: {
      handleSubmit () {
        const body = {
          domain: this.isSimulation ? this.enterpriseID : utils.getDomain(),
          name: this.name,
          ni: this.ni,
          phone: this.phone
        }
        
        if (!this.name || this.name.length === 0
        || !this.ni || this.ni.length === 0
        || !this.phone || this.phone.length === 0) { 
          this.error = true
          return
        }
        const that = this
        this.loading = true
        axios.post(utils.getAPIURL('utils/rcovid', false), body)
        .then(() => {
          this.name = '',
          this.ni = '',
          this.phone = '',
          this.snackbar = true
        })
        //.catch(function (error) {
        //   if (!error.response || error.response.status === 403) {
        //     // window.location.href = '/#/login'
        //     that.loading = false
        //   }
        //})
        .finally(() => {
          this.loading = false
          this.error = false
        })
      }
    }
  }
</script>
<style scoped>
  .label-form {
    margin-bottom: 10px;
  }
</style>